import {
  DATE_LONG,
  formatDate as format,
  getTime,
  NAMED_WEEKDAY_WITH_YEAR_WITH_TIME,
} from '@/lib/dateTime'

// Locale-aware, e.g. en-US '11/20/2026' / '11:00 AM', de '20.11.2026' / '11:00'.
export const formatDate = (date) => format(date, DATE_LONG)

export const formatDateWithWeekdayName = (date, appLocale) =>
  format(date, NAMED_WEEKDAY_WITH_YEAR_WITH_TIME, appLocale)

export const formatTime = (date) => getTime(date)
